import DOMPurify from 'dompurify';

export const sanitizeHtml = (content: string) => {
  return DOMPurify.sanitize(content);
};
